exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RouterBuyRequests_component_1LvI {\n  margin-bottom: 20px;\n\n  width: 100%;\n  max-width: none;\n\n  text-align: left\n}\n\n.RouterBuyRequests_component_1LvI:last-child {\n  margin-bottom: 0;\n}\n\n.RouterBuyRequests_button_2PaC {\n  margin-top: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"component": "RouterBuyRequests_component_1LvI",
	"button": "RouterBuyRequests_button_2PaC"
};